
import React from 'react';
import { TableHead, TableHeader, TableRow } from "@/components/ui/table";

interface ProductsTableHeaderProps {
  showActions?: boolean;
}

const ProductsTableHeader = ({ showActions = true }: ProductsTableHeaderProps) => {
  return (
    <TableHeader className="reference-table-header">
      <TableRow>
        <TableHead className="reference-table-cell-header">Produit</TableHead>
        <TableHead className="reference-table-cell-header">Prix unitaire</TableHead>
        <TableHead className="reference-table-cell-header">Quantité</TableHead>
        <TableHead className="reference-table-cell-header text-right">Total</TableHead>
        {showActions && <TableHead className="w-10 reference-table-cell-header">Actions</TableHead>}
      </TableRow>
    </TableHeader>
  );
};

export default ProductsTableHeader;
